module.exports = __webpack_public_path__ + "3d434c3b2a3664ce0d607e065b2960e1.jpg";